import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'pla-basic-input',
  templateUrl: './basic-input.component.html',
  styleUrls: ['./basic-input.component.scss']
})
export class BasicInputComponent implements OnInit {
  @Input() public maxLength: number = 20;
  @Input() public prefixIcon: string = '';
  @Input() public inputType: string = 'text';
  @Input() public customChangerClasses: string = '';
  @Input() public changingPlaceholder: boolean = false;
  @Input() public fixedHeight: boolean = true;
  @Input() public weight: string = 'fw-normal';
  @Input() public emitOnInput: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public canUsePredictive: boolean = false;
  @Input() public placeholder: string = 'What can we find for you?';
  @Input() public searchTexts: string[] = [];
  @Input() public validator: (value: string) => boolean = () => true;

  public focused: boolean = false;
  private debounceTimer: number = -1;

  @Input() public value: string = '';
  @Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();

  public inputId: string = this.makeid(5);

  constructor() { }

  ngOnInit(): void {
    // console.log(this);
  }

  private makeid(length): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  public KeyDown(event: KeyboardEvent): void {
    if (event.code !== 'Enter' && this.emitOnInput) { this.DebounceInput() }
    if (event.code === 'Enter') {
      event.stopImmediatePropagation();
      this.valueChange.emit(this.value);
    }
  }

  private DebounceInput(): void {
    window.clearTimeout(this.debounceTimer)
    this.debounceTimer = window.setTimeout(() => {
      this.valueChange.emit(this.value);
    }, 700)
  }

  public FocusElement(): void {
    document.getElementById(`${this.inputId}-input`).focus();
  }

  public SetFocus(value: boolean): void {
    this.focused = value;
  }
}
